module.exports = __webpack_public_path__ + "img/de_bg_1.1eb08ebe.jpeg";